import SEO from './composants/SEO';
import { SEO_PAGES } from './donnees/seoPages'; 
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageQuiSommesNous.css';
import logoComplet from './assets/logo-complet.png';
import { useAuth } from './AuthContext';
import Navigation from './composants/Navigation';
import PiedDePage from './composants/PiedDePage';
export default function PageQuiSommesNous() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="qsn-container">
<SEO {...SEO_PAGES.quiSommesNous} />
      <Navigation />

      {/* ══ HERO ══ */}
      <section className="qsn-hero">
        <div className="qsn-hero-content">
          <div className="qsn-badge">🇭🇹 Notre Histoire</div>
          <h1>Bâtir l'avenir digital d'Haïti,<br />une idée à la fois</h1>
          <p>PEFEP Site est né d'une conviction profonde : la technologie doit être accessible à tous les Haïtiens, peu importe leur niveau technique ou leur budget.</p>
        </div>
      </section>

      {/* ══ FONDATEUR ══ */}
      <section className="qsn-section">
        <div className="qsn-container-inner">
          <div className="qsn-fondateur">
            <div className="qsn-fondateur-photo">
              <div className="qsn-photo-placeholder">
                <span>IP</span>
                <p>Isaac PRESMY</p>
              </div>
            </div>
            <div className="qsn-fondateur-texte">
              <div className="qsn-section-badge">Le Fondateur</div>
              <h2>Isaac PRESMY</h2>
              <h3>Entrepreneur Digital • Visionnaire • PDG de PEFEP GROUPE</h3>
              <p>Isaac PRESMY est un entrepreneur haïtien passionné par deux choses : <strong>son pays et la technologie</strong>. Convaincu que l'innovation numérique peut transformer le quotidien des Haïtiens, il a consacré sa carrière à construire des solutions digitales accessibles, pratiques et adaptées au contexte local.</p>
              <p>Journaliste de formation, formateur certifié en développement personnel et professionnel, directeur de Radio Méro Léo FM 96.9, Isaac cumule les casquettes avec une énergie rare. Mais derrière tous ces rôles, une seule mission le guide : <strong>simplifier la vie de ses clients grâce à des produits et services innovants.</strong></p>
              <p>Son rêve ? Faire d'Haïti un pays où chaque entrepreneur, chaque organisation, chaque église ou ONG peut avoir une présence digitale professionnelle — sans barrières techniques, sans coûts prohibitifs, sans intermédiaires inutiles.</p>
              <div className="qsn-citation">
                <span className="qsn-guillemet">"</span>
                <p>J'aime mon pays et j'aime la technologie. PEFEP Site, c'est ma façon de mettre les deux au service des Haïtiens.</p>
                <strong>— Isaac PRESMY, PDG PEFEP GROUPE</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ CO-FONDATRICE ══ */}
      <section className="qsn-section qsn-section-gray">
        <div className="qsn-container-inner">
          <div className="qsn-fondateur reverse">
            <div className="qsn-fondateur-texte">
              <div className="qsn-section-badge">La Co-Fondatrice</div>
              <h2>Fabiola Derossaint PRESMY</h2>
              <h3>Co-Fondatrice • Pilier stratégique de PEFEP GROUPE</h3>
              <p>À côté d'Isaac, il y a Fabiola. Depuis le premier jour, elle est la co-architecte de l'aventure PEFEP. Son sens de l'organisation, sa rigueur et sa vision ont été des atouts décisifs dans la construction de ce qui est devenu aujourd'hui PEFEP GROUPE.</p>
              <p>Ensemble, Isaac et Fabiola forment un duo complémentaire qui incarne les valeurs fondamentales de PEFEP : <strong>intégrité, excellence, innovation et amour du service.</strong></p>
              <div className="qsn-citation">
                <span className="qsn-guillemet">"</span>
                <p>Nous avons commencé avec très peu, mais avec une vision claire et une détermination sans faille. Chaque étape de PEFEP a été construite avec amour.</p>
                <strong>— Fabiola Derossaint PRESMY, Co-Fondatrice</strong>
              </div>
            </div>
            <div className="qsn-fondateur-photo">
              <div className="qsn-photo-placeholder" style={{ background: 'linear-gradient(135deg, #00A651, #8CC63F)' }}>
                <span>FP</span>
                <p>Fabiola PRESMY</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ TIMELINE ══ */}
      <section className="qsn-section">
        <div className="qsn-container-inner">
          <div className="qsn-section-badge" style={{ textAlign: 'center', display: 'block', marginBottom: 16 }}>Notre Parcours</div>
          <h2 style={{ textAlign: 'center', color: '#002D62', marginBottom: 8 }}>De l'École Professionnelle au SaaS IA</h2>
          <p style={{ textAlign: 'center', color: '#666', marginBottom: 50 }}>Une histoire de croissance, de persévérance et d'innovation constante.</p>

          <div className="qsn-timeline">

            <div className="qsn-timeline-item">
              <div className="qsn-timeline-annee">2022</div>
              <div className="qsn-timeline-content">
                <div className="qsn-timeline-icon">🏫</div>
                <h3>PEFEP École Professionnelle</h3>
                <p>Tout commence avec une école professionnelle fondée par Isaac et Fabiola à Léogâne. La mission : former des jeunes Haïtiens aux compétences pratiques et professionnelles. C'est ici que naît l'ADN PEFEP — <strong>former, accompagner, transformer.</strong></p>
              </div>
            </div>

            <div className="qsn-timeline-item">
              <div className="qsn-timeline-annee">2023</div>
              <div className="qsn-timeline-content">
                <div className="qsn-timeline-icon">🎓</div>
                <h3>PEFEP Online Académie</h3>
                <p>L'éducation passe au digital. Lancement de PEFEP Online Académie — une plateforme de cours en ligne dédiée au <strong>développement personnel et professionnel</strong>. Des milliers d'apprenants haïtiens accèdent à des formations certifiantes, gratuitement et en ligne.</p>
              </div>
            </div>

            <div className="qsn-timeline-item">
              <div className="qsn-timeline-annee">2024</div>
              <div className="qsn-timeline-content">
                <div className="qsn-timeline-icon">🏢</div>
                <h3>PEFEP GROUPE</h3>
                <p>L'écosystème s'élargit. Naissance de <strong>PEFEP GROUPE</strong> — une agence digitale à part entière basée à Léogâne, Haïti. Création de sites web, SEO, marketing digital et accompagnement stratégique pour les entreprises, ONG et organisations haïtiennes.</p>
              </div>
            </div>

            <div className="qsn-timeline-item">
              <div className="qsn-timeline-annee">2025</div>
              <div className="qsn-timeline-content">
                <div className="qsn-timeline-icon">🚀</div>
                <h3>PEFEP Site — La révolution IA</h3>
                <p>L'audace ultime. Lancement de <strong>PEFEP Site</strong>, filiale technologique de PEFEP GROUPE et première plateforme haïtienne de génération de site web par intelligence artificielle. Un rêve devenu réalité : permettre à n'importe quel Haïtien de créer un site professionnel en 30 minutes.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ══ MISSION VISION VALEURS ══ */}
      <section className="qsn-section qsn-section-blue">
        <div className="qsn-container-inner">
          <div className="qsn-mvv-grid">
            <div className="qsn-mvv-card">
              <div className="qsn-mvv-icon">🎯</div>
              <h3>Notre Mission</h3>
              <p>Simplifier la vie de nos clients grâce à des produits et services digitaux innovants, accessibles et adaptés au contexte haïtien. Permettre à chaque organisation haïtienne d'avoir une présence digitale professionnelle, quel que soit son budget ou son niveau technique.</p>
            </div>
            <div className="qsn-mvv-card">
              <div className="qsn-mvv-icon">🌟</div>
              <h3>Notre Vision</h3>
              <p>Devenir la référence du digital en Haïti et dans la Caraïbe. Contribuer activement au développement économique d'Haïti en démocratisant l'accès à la technologie et en formant la prochaine génération d'entrepreneurs digitaux haïtiens.</p>
            </div>
            <div className="qsn-mvv-card">
              <div className="qsn-mvv-icon">💎</div>
              <h3>Nos Valeurs</h3>
              <p><strong>Intégrité</strong> — Nous faisons ce que nous promettons.<br /><strong>Innovation</strong> — Nous cherchons toujours mieux.<br /><strong>Excellence</strong> — Nous livrons du professionnel.<br /><strong>Service</strong> — Le client est au cœur de tout.<br /><strong>Amour du pays</strong> — Haïti d'abord.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══ CHIFFRES ══ */}
      <section className="qsn-section">
        <div className="qsn-container-inner">
          <div className="qsn-section-badge" style={{ textAlign: 'center', display: 'block', marginBottom: 16 }}>PEFEP en chiffres</div>
          <h2 style={{ textAlign: 'center', color: '#002D62', marginBottom: 40 }}>Une croissance construite pas à pas</h2>
          <div className="qsn-chiffres-grid">
            <div className="qsn-chiffre-card">
              <div className="qsn-chiffre-num">3+</div>
              <div className="qsn-chiffre-label">Années d'existence</div>
            </div>
            <div className="qsn-chiffre-card">
              <div className="qsn-chiffre-num">4</div>
              <div className="qsn-chiffre-label">Entités PEFEP</div>
            </div>
            <div className="qsn-chiffre-card">
              <div className="qsn-chiffre-num">11</div>
              <div className="qsn-chiffre-label">Secteurs couverts</div>
            </div>
            <div className="qsn-chiffre-card">
              <div className="qsn-chiffre-num">100%</div>
              <div className="qsn-chiffre-label">Haïtien & Fier</div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ CTA ══ */}
      <section className="qsn-cta">
        <div className="qsn-container-inner" style={{ textAlign: 'center' }}>
          <h2>Prêt à rejoindre l'aventure PEFEP Site ?</h2>
          <p>Créez votre site web professionnel en moins de 30 minutes et rejoignez les organisations haïtiennes qui font confiance à PEFEP Site.</p>
          <button type="button" className="qsn-cta-btn" onClick={() => navigate('/connexion')}>
            🚀 Créer mon site maintenant
          </button>
          <button type="button" className="qsn-cta-btn-outline" onClick={() => navigate('/contact')}>
            📞 Nous contacter
          </button>
        </div>
      </section>
      <PiedDePage />

    </div>
  );
}